import { httpsCallable } from 'firebase/functions';
import { functions } from '../platform/firebase/clients';

export type HarborJobArtifactId = 'results' | 'trajectories';

export interface HarborJobArtifact {
  id: HarborJobArtifactId;
  label: string;
  sizeBytes: number | null;
}

export interface HarborJob {
  id: string;
  status: string;
  taskName: string | null;
  ownerEmail: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  artifacts: HarborJobArtifact[];
}

export interface HarborJobsPage {
  jobs: HarborJob[];
  nextPageToken: string | null;
}

interface HarborJobActionResponse {
  jobId: string;
  status?: string;
  cancelRequested?: boolean;
  deleted?: boolean;
}

export interface HarborArtifactDownload {
  jobId: string;
  artifactId: HarborJobArtifactId;
  filename: string;
  downloadUrl: string;
  expiresAt: string;
}

export async function listHarborJobs(pageToken?: string | null): Promise<HarborJobsPage> {
  const callable = httpsCallable<{ pageToken?: string }, HarborJobsPage>(
    functions,
    'listAdminHarborJobs',
  );
  const result = await callable(pageToken ? { pageToken } : {});
  return result.data;
}

export async function cancelHarborJob(jobId: string): Promise<void> {
  const callable = httpsCallable<{ jobId: string }, HarborJobActionResponse>(
    functions,
    'cancelAdminHarborJob',
  );
  await callable({ jobId });
}

export async function deleteHarborJob(jobId: string): Promise<void> {
  const callable = httpsCallable<{ jobId: string }, HarborJobActionResponse>(
    functions,
    'deleteAdminHarborJob',
  );
  await callable({ jobId });
}

export async function getHarborJobArtifactDownload(
  jobId: string,
  artifactId: HarborJobArtifactId,
): Promise<HarborArtifactDownload> {
  const callable = httpsCallable<
    { jobId: string; artifactId: HarborJobArtifactId },
    HarborArtifactDownload
  >(functions, 'downloadAdminHarborArtifact');
  const result = await callable({ jobId, artifactId });
  return result.data;
}
